import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import Edit from "./Edit";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { Link } from "react-router-dom";
import core from "store/core";
import { toJalali } from "lib/helpers";
import { LIVESTREAM_RTMP_BASE_URL } from "config/env";
export default function Festivals() {
  const path = {
    baseRoute: "/panel/lives",
    aliasName: "لایو ها",
    type: "Live",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    create,
    update,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();
  const core = useCore();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(false);

  useEffect(() => {
    dispatch(getList(path));
    core.dispatch(core.getSliders());
    core.dispatch(core.getMenus());
    return () => {
      dispatch(clear());
    };
  }, []);
  const accesses={
    FREE:'رایگان',
    TICKET:'بلیت',
  }
  return (
    <>
      <Add
        title="لایو جدید"
        show={showAdd}
        close={() => {
          setShowAdd(false);
        }}
        submit={(values) => {
          dispatch(
            create(path, values, () => {
              handleSuccessMessages("لایو  با موفقیت اضافه شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Edit
        item={item}
        title="ویرایش لایو"
        show={showEdit}
        close={() => {
          setShowEdit(false);
        }}
        submit={(values, id) => {
          dispatch(
            update(path, id, values, () => {
              handleSuccessMessages("لایو  با موفقیت ویرایش شد");
              dispatch(getList(path));
            })
          );
        }}
      />

      <Delete
        title="حذف لایو "
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item.id, () => {
              handleSuccessMessages("لایو با موفقیت حذف شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">لایو ها</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            <button
              onClick={() => {
                setShowAdd(true);
              }}
              className="btn btn-primary shadow-md mr-2"
            >
              افزودن لایو
            </button>
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
          {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item) => (
                    <div className="intro-x w-full flex flex-col my-4 p-2">
                      <div className="flex  bg-white justify-between p-3">
                      <td className="w-16 text-center">شناسه:{item.id}</td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                         عنوان:{item.title}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                         دسترسی:{accesses[item.access]}
                        </p>
                      </td>
                      <td className="table-report__action w-80">
                        <div className="flex justify-center items-center">
                        {item.access=='TICKET'&&<Link
                              to={`/products/lives/${item.id}/tickets`}
                            >
                              <a className="flex items-center ml-3 cursor-pointer">
                                <Icons.CreditCard className="w-4 h-4 ml-1" />
                                بلیت ها
                              </a>
                            </Link>}
                          <a
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowEdit(true);
                            }}
                          >
                            <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                            ویرایش{" "}
                          </a>
                          <a
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1 " />
                            حذف{" "}
                          </a>
                        </div>
                      </td>
                      </div>
                      <div className="flex justify-between p-4 border-2 bg-white">
                      <div className="flex flex-col">
                      <td className="text-center">زمان شروع:{item.live_start_at?
                            toJalali(item.live_start_at, "jYYYY-jMM-jDD HH:mm"):'بدون زمان'}</td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                         درایور:{item.driver_type}
                        </p>
                       
                      </td>
                      </div>
                      <div className="flex flex-col items-end">
                      {item.driver_type=='HashureLiveStream'&&
                       <>
                       {item.status==-1&&<button onClick={()=>{core.dispatch(core.createLiveStream(item.id,()=>{
                        handleSuccessMessages('سرور روشن شد!');
                        dispatch(getList(path));
                       }))}}  className="btn btn-warning shadow-md">
                       <Icons.Play className="w-4 h-4 ml-1" />
                        ساخت استریم</button>}
                       {item.livestream_id&&
                       <>
                       {item.status!=-1&&<button onClick={()=>{core.dispatch(core.deleteLiveStream(item.id,()=>{
                        handleSuccessMessages('سرور متوقف شد!');
                        dispatch(getList(path));
                       }))}}  className="btn btn-warning shadow-md">
                       <Icons.StopCircle className="w-4 h-4 ml-1" />
                        حذف استریم</button>}
                       <td>
                           <p className="font-medium whitespace-nowrap text-center">
                            stream_id:{item.livestream_id}
                          </p>
                        </td>
                        <td>
                           <p className="font-medium whitespace-nowrap text-center">
                            OBS_SERVER:{`${LIVESTREAM_RTMP_BASE_URL}:${item.livestream_port}/live`}
                          </p></td>
                          <td>
                           <p className="font-medium whitespace-nowrap text-center">
                            OBS_KEY:{item.livestream_key}
                          </p></td>
                          
                        </>
                        }
                        </>
                      }
                      {item.driver_type=='HashureLive'&&
                       <>
                       <td>
                           <p className="font-medium whitespace-nowrap text-center">
                           src:{item.driver_source}
                          </p></td>
                        
                        </>
                      }
                      </div>
                    </div>
                    </div>
                  ))}
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
